import { createFileRoute } from '@tanstack/react-router'

import PagePocIndex from '@/pages/PagePocIndex'

export const Route = createFileRoute('/poc/')({
  component: PagePocIndex
})
